import { styled } from '@mui/material/styles';
import {
  Typography,
  Card,
} from '@mui/material';
import { Button, Box } from '@mui/material';

export const ContentContainer = styled('div')({
  position: 'relative',
  minHeight: 'calc(100vh - 64px)',
  paddingBottom: '100px',
  overflowY: 'auto',
  marginLeft: 70
});

export const MainContent = styled('div')({
  padding: '20px',
  marginBottom: '10px',
});

export const CenteredCard = styled(Card)({
  maxWidth: '100%',
  margin: '20px',
  marginTop: '80px',
  border: '1px solid dodgerblue',
  height: '50vh',  // Default height for regular screens

  // Responsive height for laptops
  '@media (min-width: 1024px) and (max-width: 1440px)': {
    height: '60vh', // Increase the height for laptops
    overflowY: 'auto',
  },

  // Height for medium screens (tablets)
  '@media (max-width: 1024px) and (min-width: 600px)': {
    height: '50vh', // Adjust for tablets
    overflowY: 'auto',
  },

  // Height for smaller screens (mobile)
  '@media (max-width: 600px)': {
    height: '70vh', // Increase height for mobile devices
    overflowY: 'auto',
  },

  // Height for larger screens
  '@media (min-width: 1440px)': {
    height: '66vh', // Adjust for larger screens
    overflowY: 'auto',
  },
});

export const StyledTableHeader = styled('th')(({ theme }) => ({
  padding: '15px',
  border: '1px solid #ddd',
  cursor: 'pointer',
  textAlign: 'center',
  verticalAlign: 'middle',
  backgroundColor: '#f2f2f2',
  borderBottom: '2px solid #ddd',
  height: '50px',
  fontSize: '16px',
  fontWeight: 'bold',
  color: '#333',
  transition: theme.transitions.create(['color', 'background-color'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  '&:hover': {
    color: '#1976D2',
    backgroundColor: '#ddd',
  },
}));

export const HeaderTitle = styled(Typography)({
  flexGrow: 1,
  fontSize: '1.4rem',
  color: '#333',
  fontWeight: 'normal',
  textAlign: 'left',
  textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
  marginLeft: '10px',
});

export const RefreshIcon = styled('img')({
  cursor: 'pointer',
  width: '40px',
  height: '40px',
  transition: 'transform 0.3s ease-in-out',
  '&:hover': {
    transform: 'rotate(360deg)',
  },
});